<div class="legend">
    <span class="legend-label" *ngFor="let legend of legendList" [class]="legend.type">
        {{legend.name |
        translate}}</span>
</div>